import { Navigate } from 'react-router-dom'
import { usePortalPermissions } from '@/hooks/usePortalPermissions'
import type { PortalPermissions } from '@/api/portal'

/** Sends the client to Overview if the tenant has switched this part of the portal off for them. */
export function RequirePortalFeature({ feature, children }: { feature: keyof PortalPermissions; children: React.ReactNode }) {
  const permissions = usePortalPermissions()
  if (permissions.loaded && !permissions[feature]) return <Navigate to="/portal/overview" replace />
  return <>{children}</>
}
